module.exports = __webpack_public_path__ + "img/vue2-semelle_gris.427872a0.png";